export const toNonNegativeCount = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
};

export const normalizeBrdChangeType = (value = '') => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'changed' || normalized === 'updated') return 'modified';
  if (normalized === 'deleted') return 'removed';
  return normalized || 'modified';
};

export const buildDisplayedSectionChangeSummary = (brdChangeAnalysis = null) => {
  const comparison = brdChangeAnalysis?.comparison && typeof brdChangeAnalysis.comparison === 'object'
    ? brdChangeAnalysis.comparison
    : {};
  const impact = brdChangeAnalysis?.impact && typeof brdChangeAnalysis.impact === 'object'
    ? brdChangeAnalysis.impact
    : {};
  const summary = (
    brdChangeAnalysis?.summary
    || comparison?.summary
    || {}
  );
  const impactSummary = impact?.summary && typeof impact.summary === 'object' ? impact.summary : {};
  const impactedItems = Array.isArray(impact?.impacted_items) ? impact.impacted_items : [];
  const generatedNumbersByType = {
    added: new Set(),
    modified: new Set(),
    removed: new Set(),
  };

  impactedItems.forEach((item) => {
    const changeType = normalizeBrdChangeType(item?.change_type || '');
    if (!generatedNumbersByType[changeType]) return;
    const explicitNumbers = Array.isArray(item?.impacted_generation_section_numbers)
      ? item.impacted_generation_section_numbers
      : [];
    const generationSections = [
      ...(Array.isArray(item?.current_generation_sections) ? item.current_generation_sections : []),
      ...(Array.isArray(item?.previous_generation_sections) ? item.previous_generation_sections : []),
    ];
    [
      ...explicitNumbers,
      ...generationSections.map((section) => section?.number),
    ].forEach((value) => {
      const number = Number(value);
      if (Number.isFinite(number) && number > 0) {
        generatedNumbersByType[changeType].add(number);
      }
    });
  });

  const generatedSummary = {
    added: toNonNegativeCount(impactSummary.added_generation_sections) || generatedNumbersByType.added.size,
    modified: toNonNegativeCount(impactSummary.modified_generation_sections) || generatedNumbersByType.modified.size,
    removed: toNonNegativeCount(impactSummary.removed_generation_sections) || generatedNumbersByType.removed.size,
  };
  generatedSummary.deleted = generatedSummary.removed;
  generatedSummary.total_changes = generatedSummary.added + generatedSummary.modified + generatedSummary.removed;

  const usesGeneratedSectionSummary = generatedSummary.total_changes > 0;
  const displaySummary = usesGeneratedSectionSummary
    ? {
      ...summary,
      ...generatedSummary,
      raw_added: toNonNegativeCount(summary.added),
      raw_modified: toNonNegativeCount(summary.modified),
      raw_removed: toNonNegativeCount(summary.removed ?? summary.deleted),
      raw_total_changes: toNonNegativeCount(summary.total_changes),
    }
    : summary;

  return {
    comparison,
    impact,
    summary,
    displaySummary,
    usesGeneratedSectionSummary,
  };
};
